export default "__VITE_ASSET__DzNattAu__"